// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Do-z","slideIn":"Eo-z"};